import { useDialogStore, type DialogState } from '../useDialogStore/useDialogStore'

export type DialogStateHookReturn<T> = [DialogState<T>['open'], DialogState<T>['data']]

/** Returns open/closed value and dialog state */
export const useDialogState = <T>(id: string): DialogStateHookReturn<T> => {
  const open = useDialogStore(({ state }) => state[id]?.open || false)
  const data = useDialogStore(({ state }) => state[id]?.data)

  return [open, data as DialogState<T>['data']]
}
